import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinCareRoutineDescription = lazyWithPreload(
  () => import('./SkinCareRoutineDescription'),
)
